import { useNavigate } from 'react-router-dom';
import AnimeStatusSelector from './AnimeStatusSelector';
import { genreLabel } from '../constants/genreLabels';

// AnimeStatusSelector is placed OUTSIDE .acard (overflow:hidden)
// to avoid the popover being clipped. .acard-outer is the anchor.
export default function AnimeCard({ anime, currentStatus }) {
  const navigate = useNavigate();
  const score = anime.mal_score || anime.score;

  return (
    <div className="acard-outer">
      <div className="acard" onClick={() => navigate(`/anime/${anime.id}`)}>
        {anime.image ? (
          <img
            className="acard__img"
            src={anime.image}
            alt={anime.title}
            loading="lazy"
            referrerPolicy="no-referrer"
          />
        ) : (
          <div className="acard__img--empty">🎬</div>
        )}

        <div className="acard__overlay">
          <div className="acard__play-icon">▶</div>
          <div className="acard__overlay-bottom">
            <span className="acard__overlay-title">{anime.title}</span>
            {(score || anime.genres?.[0]) && (
              <div className="acard__overlay-meta">
                {score && <span>★ {score}</span>}
                {anime.genres?.[0] && <span>{genreLabel(anime.genres[0])}</span>}
              </div>
            )}
          </div>
        </div>

        <div className="acard__meta">
          <p className="acard__title">{anime.title}</p>
          {anime.releaseDate && <p className="acard__year">{anime.releaseDate}</p>}
        </div>
      </div>

      <div className="acard__status-wrap">
        <AnimeStatusSelector
          animeId={anime.id}
          currentStatus={currentStatus}
        />
      </div>
    </div>
  );
}
